import { findCard } from '../engine/helpers'
import type { PlayerAction } from '../types/actions'
import type { MatchState } from '../types/state'

const PASSCODE = /^\d{1,10}$/

function passcode(id: string | null | undefined): string {
  return id && PASSCODE.test(id) ? id : ''
}

function uidCard(state: MatchState, uid: string | null | undefined): string {
  if (!uid) return ''
  return passcode(findCard(state, uid)?.instance.cardId)
}

/**
 * Passcode of the card the open window is about: the card asking for a
 * pick or a call, the newest chain link, the monster that opened a response
 * window, or the attacker. Empty when nothing is pending or the card is hidden.
 */
export function duelPendingCard(state: MatchState): string {
  if (state.pendingTargets) return passcode(state.pendingTargets.cardId)
  if (state.pendingFlipEffect) return passcode(state.pendingFlipEffect.cardId)
  if (state.pendingCoinCall) return passcode(state.pendingCoinCall.cardId)
  if (state.pendingChoice) return passcode(state.pendingChoice.cardId)
  if (state.pendingChainOrder) return passcode(state.pendingChainOrder.cards[0]?.cardId)
  const top = state.chain[state.chain.length - 1]
  if (top) return passcode(top.cardId) || uidCard(state, top.sourceUid)
  if (state.pendingPriority) return uidCard(state, state.pendingPriority.triggerUid)
  if (state.pendingAttack) return uidCard(state, state.pendingAttack.attackerUid)
  return ''
}

/**
 * Passcode of the card a play names (summoned, activated, attacking).
 * Empty for answers that only carry a request id, and for hidden cards.
 */
export function duelActionCard(state: MatchState, action: PlayerAction): string {
  if (!action || typeof action !== 'object') return ''
  const named = action as { cardUid?: unknown; attackerUid?: unknown }
  if (typeof named.cardUid === 'string') return uidCard(state, named.cardUid)
  if (typeof named.attackerUid === 'string') return uidCard(state, named.attackerUid)
  return ''
}
